import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-cards-subsection" }
const _hoisted_2 = { class: "cards-grid" }
const _hoisted_3 = { class: "info-card" }
const _hoisted_4 = { class: "card-icon-wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Email", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "card-description" }, "contact@florisuite.com", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "card-subdescription" }, "Nous répondons sous 24h", -1)
const _hoisted_9 = { class: "info-card" }
const _hoisted_10 = { class: "card-icon-wrapper" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Téléphone", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "card-description" }, "+33 788029767", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "card-subdescription" }, "Lun-Ven, 9h-18h", -1)
const _hoisted_15 = { class: "info-card" }
const _hoisted_16 = { class: "card-icon-wrapper" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Adresse", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "card-description" }, "254 rue vendome", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "card-subdescription" }, "69003 Lyon, France", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "card-icon",
            alt: "Mail",
            src: _ctx.mailIcon
          }, null, 8, _hoisted_5)
        ]),
        _hoisted_6,
        _hoisted_7,
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("img", {
            class: "card-icon",
            alt: "Phone",
            src: _ctx.phoneIcon
          }, null, 8, _hoisted_11)
        ]),
        _hoisted_12,
        _hoisted_13,
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("img", {
            class: "card-icon",
            alt: "Map pin",
            src: _ctx.mapPinIcon
          }, null, 8, _hoisted_17)
        ]),
        _hoisted_18,
        _hoisted_19,
        _hoisted_20
      ])
    ])
  ]))
}